import React from 'react';
import { GraduationCap } from 'lucide-react';
import ProjectCaseStudy from '../components/ProjectCaseStudy';

const ProjectEight = () => {
  return (
    <ProjectCaseStudy
      title="PassPoint — Saudi Exam-Prep Platform"
      tagline="A bilingual Q-bank and practice platform for the Saudi Pharmacist Licensure Exam (SPLE)."
      icon={<GraduationCap className="w-7 h-7" />}
      context="Pharmacy graduates in Saudi Arabia preparing for the SPLE had no focused, bilingual question bank — study material was scattered, English-only, and gave no signal on where candidates were actually weak."
      built="We built PassPoint end to end: a comprehensive SPLE Q-bank with tutor and timed-exam modes, AI-powered answer explanations, gamified learning (points, streaks, leaderboards), deep performance analytics, a fully bilingual Arabic–English interface, and subscription billing via hosted checkout with Apple Pay support."
      stack={['React', 'Vite', 'Supabase', 'Tailwind CSS', 'i18n', 'AI explanations', 'StreamPay']}
      highlights={[
        'Bilingual Arabic & English UI with instant medical-term translation',
        'AI-generated explanations and study guidance per question',
        'Gamification: points, streaks, leaderboards',
        'Real exam simulation with timed sessions and analytics',
        'Cross-platform sync across web, mobile, and tablet',
      ]}
      screenshots={[
        { src: '/passpoint/hero.png', caption: 'passpoint.co — homepage (Arabic default)' },
        { src: '/passpoint/full.png', caption: 'Feature and analytics sections' },
      ]}
      liveUrl="https://passpoint.co"
    />
  );
};

export default ProjectEight;
